import styled, { css } from 'styled-components';

import { fadeIn, slideLeft, slideRight } from '../../constants/animations';
import { colors, fontWeights, zIndexes } from '../../theme';
import type { DrawerSide } from '../../types';
import { hexWithOpacity } from '../../utils';

import {
  fadeInDuration,
  fadeOutDelay,
  fadeOutDuration,
  slideDuration,
} from './constants';

interface DrawerContainerProps {
  $isExpanded: boolean;
  $side: DrawerSide;
}

const animation = {
  right: slideRight,
  left: slideLeft,
};

const translateX = {
  right: '100%',
  left: '-100%',
};

const positionStyles = {
  right: css`
    right: 0;
  `,
  left: css`
    left: 0;
  `,
};

export const DrawerContainer = styled.div<DrawerContainerProps>`
  ${({ $side }) => positionStyles[$side]}
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: ${zIndexes.actionSheet};
  display: flex;
  flex-direction: column;
  background-color: ${colors.white};
  box-shadow: 4px 4px 20px ${hexWithOpacity(colors.navy, 0.5)};
  transform: ${({ $isExpanded, $side }) =>
    !$isExpanded && `translateX(${translateX[$side]})`};
  transition: ${({ $isExpanded }) =>
    !$isExpanded && `transform ${slideDuration}ms ease-out`};
  animation: ${({ $side }) => animation[$side]} ${slideDuration}ms ease-in;
`;

export const StickyArea = styled.div`
  padding: 0 24px;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 28px 38px 0;
`;

export const Title = styled.h3`
  display: flex;
  margin: 0;
  color: ${colors.navy};
  font-weight: ${fontWeights.medium};
  font-size: 24px; /* TODO Standardize font sizes */
`;

export const ScrollableArea = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  margin-top: 24px;
  padding: 0 40px 24px;
  overflow: auto;
`;

export const DrawerFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 38px;
  background-color: ${colors.pearl};
`;

export const Overlay = styled.div<{ $isExpanded: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${zIndexes.actionSheet};
  width: 100%;
  height: 100%;
  background: ${hexWithOpacity(colors.navy, 0.8)};
  opacity: ${({ $isExpanded }) => !$isExpanded && '0'};
  transition: ${({ $isExpanded }) =>
    !$isExpanded && `opacity ${fadeOutDuration}ms ease-out ${fadeOutDelay}ms`};
  animation: ${fadeInDuration}ms ease-out ${fadeIn};
`;
